import React from 'react';
import styled from '@emotion/styled';
import { Container, Text, useBreakpoint } from 'basis';
import { useStoreValue } from 'store';
import { isFeatureOn } from 'featureToggles';

const Banner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const TextWrapper = styled.div`
  p {
    font-size: 12px;
  }
`;

const BannerContainer = styled.div`
  padding: 0 12px 0 20px;
  margin: 16px;
  border-left: 12px solid #6e6863;
  & > div[data-testid='offer-title'] p {
    font-weight: 600;
    font-family: 'Latitude Sans', sans-serif;
  }

  & > div[data-testid='offer-description'] {
    ${props => `
    ${`@media (min-width: ${props.theme.screenSize.lg})`} {
    display: flex;
    align-items: baseline;
    gap: 0.2rem;
    }
    `}
  }

  ${props => `
    ${`@media (min-width: ${props.theme.screenSize.md})`} {
        margin: 16px 0 16px 44px;
        padding: 0 12px 0 24px;
        width: 1220px;
    }
    `}
`;

export function BalanceTransferOffer() {
  const [storeState] = useStoreValue();
  const breakpoint = useBreakpoint();
  if (!isFeatureOn('offerTitle') || !storeState.offer || storeState.offer.status !== 'VALID') {
    return null;
  }

  return (
    <Banner>
      <BannerContainer>
        <Container testId="offer-title">
          <Text>{storeState.offer.title}</Text>
        </Container>
        {['xs'].includes(breakpoint) ? (
          <Container margin="1 0 1 0" testId="offer-description">
            <Text textStyle="body2">{storeState.offer.description}</Text>
            {storeState.offer.promoEnd && (
              <Container margin="1 0 1 0" testId="offer-tnc">
                <TextWrapper>
                  <Text textStyle="body2">
                    New customers only, must be approved by {storeState.offer.promoEnd}. T&Cs apply.
                  </Text>
                </TextWrapper>
              </Container>
            )}
          </Container>
        ) : (
          <>
            <Container margin="1 0 1 0" testId="offer-description">
              <Text textStyle="body2">{storeState.offer.description}.</Text>
              {storeState.offer.promoEnd && (
                <TextWrapper>
                  <Text textStyle="body2">
                    New customers only, must be approved by {storeState.offer.promoEnd}. T&Cs apply.
                  </Text>
                </TextWrapper>
              )}
            </Container>
          </>
        )}
      </BannerContainer>
    </Banner>
  );
}
